import React, { Component } from 'react'
import RequestManager from "../../singletons/RequestManager/RequestManager";

export default class Resonf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reasonss: [],
        
        };
        
      }


  
      async componentDidMount() {
        let params = {};
        let requestManager = new RequestManager();
    
        let responses = await requestManager.getResponseFromPredefinedQuery(
          "getRegionss",
          
        );

        const array_fetch_data=[]
        
        responses.data.regions.edges.forEach(function(element){

            array_fetch_data.push(element.node)

        });
        console.log(array_fetch_data)
        
        this.setState({reasonss:responses.data.regions.edges})

        
    }


    
      
    render() {

        const data = this.state.reasonss
        console.log(data,"so")
        
        return (
            <div>
          {this.state.reasonss.map((todo, index) => {
                      return (
                        <tr
                        key={todo.node.name}
                        >



                          <td>{todo.node.name}</td>
                          
                       
                         
                        </tr>
                      );
                    })}
               
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/TrackOrder/Resonf.js